import React, { useState, useEffect } from 'react';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import Label from '@/components/form/Label/Label';
import { useSelector } from 'react-redux';
import HelmetComponent from '@/components/general/Helmet/HelmetComponent';
import './BlogView.scss';

const YouTubeEmbed = () => {
  return (
    <>
      <FlexContainer className={'width100 m-hide'}>
        <iframe
          width="60%"
          height="315"
          src="https://www.youtube.com/embed/x-3jXqI1jS4"
          title="YouTube Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </FlexContainer>
      <FlexContainer className={'width100 d-hide'}>
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/x-3jXqI1jS4"
          title="YouTube Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </FlexContainer>
    </>
  );
};

const BlogEntry = (props) => {
  const { entryData, setDetailEntryData } = props;
  return (
    <FlexContainer
      className={'flex-column width100 margb20'}
      onClick={() => setDetailEntryData(entryData)}
    >
      <FlexContainer className={'width100 bgBlue400 height-220px'}>
        {console.log(entryData?.entryImage)}
        <img
          src={entryData?.entryImage}
          alt="Foto 1"
          style={{ width: '100%', height: '220px' }}
          className={''}
        />
      </FlexContainer>
      <FlexContainer className={'flex-column width100 height-220px'}>
        <Label className="text-12 margtb14">{entryData?.post_date}</Label>
        <Label className="text-18 margb40 margt10 bold">
          <strong>{entryData?.post_title}</strong>
        </Label>
        <Label className="text-16 margb14">
          {entryData?.post_detail?.substring(10, 150) + '...'}
        </Label>
        {/* <Label className="text-8 margb14">{entryData?.post_id}</Label> */}
        {/* <Label className="text-8 margb14">{entryData?.post_keywords}</Label> */}
        {/* <Label className="text-8 margb14">{entryData?.author_id}</Label> */}
        {/* <Label className="text-8 margb14">{entryData?.type_id}</Label> */}
        {/* <Label className="text-8 margb14">{entryData?.state_id}</Label> */}
      </FlexContainer>
    </FlexContainer>
  );
};

const EntriesRow = (props) => {
  const { category, entriesData, setDetailEntryData } = props;
  return (
    <FlexContainer className={'width100 flex-column margtb30 m-margtb20'}>
      <Label className="text-32 m-text-24 marglr20 m-marglr0 margt20 m-margt10 margb60 m-margb40 bold">
        <strong>Entradas populares en la categoría {category}</strong>
      </Label>
      <FlexContainer className={'m-flex-column padlr20 m-padlr0 width100 gap-10'}>
        {entriesData.map((entry, index) => (
          <BlogEntry key={index} entryData={entry} setDetailEntryData={setDetailEntryData} />
        ))}
      </FlexContainer>
    </FlexContainer>
  );
};

const Blog = (props) => {
  const { spacesDataFromBackend } = props;
  const [isShowDetail, setShowDetail] = useState(false);
  const [detailData, setDetailData] = useState({});
  const lenguageData = useSelector((state) => state.lenguage.lang);
  const esDescription =
    'Explora tendencias de coworking, productividad y trabajo remoto con Popnest. Consejos, inspiración y espacios flexibles para profesionales modernos.';
  const enDescription =
    'Explore coworking trends, productivity tips, and remote work insights with Popnest. Inspiration and flexible spaces for modern professionals.';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const setDetailEntryData = (entryData) => {
    window.scrollTo(0, 0);
    setShowDetail(true);
    setDetailData(entryData);
    const currentPath = window.location.pathname;
    const newPath = `${currentPath}-detail`;

    window.history.pushState({}, '', newPath);
  };

  const closeDetailEntryData = () => {
    window.scrollTo(0, 0);
    setShowDetail(false);
    const newPath = 'blog-popnest';
    window.history.pushState({}, '', newPath);
  };

  const spacesCatEntriesData = [
    {
      post_id: '1',
      post_keywords:
        'Talento empresarial, gestión de talento, contratación de empleados, mercado laboral, competencia por talento, retención de empleados, oferta y demanda de talento, contratación efectiva, optimización de talento, gestión de recursos humanos',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: '¿El talento que contratas impulsa tu empresa o solo llena vacantes?',
      post_detail:
        'Vivimos en mercados complejos, saturados de oferta y demanda. En mercados con excesiva oferta se compite por captar la atención de las personas, frente a mercados con poca oferta donde la finalidad es mantener a los empleados en la organización.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4D12AQGq5fqWxwVkLA/article-cover_image-shrink_720_1280/B4DZUla2hEG4AI-/0/1740089553909?e=1749081600&v=beta&t=naBOiSSIM1P4h-7uuLoDm8ZDIppNHC9ac6yYcLe6gq0',
      post_date: '20.02.25',
      longDescription: `
           <p>Vivimos en un entorno de trabajo cada vez más competitivo, donde la oferta y demanda de talento es clave para el éxito de las organizaciones. En mercados saturados de oferta, las empresas luchan por atraer a los mejores talentos, mientras que en mercados con escasa oferta, la principal estrategia es la retención de empleados.</p>
  <p>En este contexto, los recursos humanos deben ser gestionados de manera estratégica para asegurar que el talento contratado no solo llene vacantes, sino que realmente impulse el crecimiento y el rendimiento de la empresa.</p>
  <p>Entre los elementos clave para una correcta gestión del talento se encuentran:</p>
  <ul>
    <li><strong>Selección adecuada:</strong> Asegurarse de que los empleados no solo cumplan con los requisitos del puesto, sino que compartan los valores y la visión de la empresa.</li>
    <li><strong>Capacitación continua:</strong> La inversión en la formación de los empleados asegura que puedan adaptarse a las constantes transformaciones del mercado.</li>
    <li><strong>Bienestar organizacional:</strong> Crear un ambiente de trabajo saludable, donde los empleados se sientan valorados y motivados, fomenta la productividad y retención.</li>
    <li><strong>Flexibilidad:</strong> Ofrecer opciones de trabajo flexible, como horarios ajustados y trabajo remoto, puede ser decisivo para atraer a los mejores talentos.</li>
  </ul>
  <p>Además, estudios recientes han demostrado que un liderazgo efectivo y la creación de espacios colaborativos son fundamentales para maximizar el rendimiento del equipo, reduciendo la rotación y mejorando la moral de los empleados.</p>
  <h4>Referencias</h4>
  <ul>
    <li><a href="https://www.forbes.com/sites/forbeshumanresourcescouncil/2023/02/10/how-to-attract-and-retain-top-talent-in-2023/">Forbes: Cómo atraer y retener talento en 2023</a></li>
    <li><a href="https://www.mckinsey.com/business-functions/organization/our-insights/leadership-in-the-age-of-talent">McKinsey: Liderazgo en la era del talento</a></li>
    <li><a href="https://www.gartner.com/en/human-resources/market-guide-for-human-resource-software">Gartner: Tendencias en la gestión de talento</a></li>
  </ul>
      `,
    },
    {
      post_id: '2',
      post_keywords:
        'Espacio de trabajo, modelo híbrido, oficina, coworking, flexibilidad, presupuesto, ubicación, entorno laboral, productividad, necesidades del equipo',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: '¿Buscas un espacio de trabajo para un modelo híbrido?',
      post_detail:
        'Estos son los factores clave a evaluar para garantizar que la oficina o coworking se alinee con las necesidades de tu equipo: presupuesto, ubicación, flexibilidad y entorno adecuado.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQGBZyB0ov4Gvg/feedshare-shrink_800/feedshare-shrink_800/0/1730232333073?e=1746662400&v=beta&t=UhV1O2BPAVgemt2fuc95u_1_GUvfJ67FWMLO218Dr2k',
      post_date: '03.11.24',
      longDescription: `
         <p>Con el auge del <strong>modelo híbrido</strong>, las empresas enfrentan nuevos desafíos al buscar espacios de trabajo que se adapten a las necesidades de sus equipos. No se trata solo de encontrar una oficina, sino de identificar un entorno que potencie la colaboración, la productividad y el bienestar.</p>
  <p>Estos son los <strong>factores clave</strong> a considerar al elegir una oficina o espacio de coworking:</p>
  <ul>
    <li><strong>Presupuesto:</strong> Ajustarse a los recursos disponibles sin comprometer la calidad del entorno laboral.</li>
    <li><strong>Ubicación:</strong> Accesibilidad para los miembros del equipo, idealmente cercana a transporte público o zonas estratégicas.</li>
    <li><strong>Flexibilidad:</strong> Espacios que permitan adaptarse a cambios en la dinámica del equipo o crecimiento del negocio.</li>
    <li><strong>Entorno adecuado:</strong> Un ambiente cómodo, profesional e inspirador que favorezca la concentración y la colaboración.</li>
  </ul>
  <p>Elegir el lugar correcto puede marcar una gran diferencia en la motivación del equipo, su compromiso y el rendimiento general. En Popnest, nos enfocamos en crear espacios que se alineen con las nuevas formas de trabajar.</p>
  <h4>Referencias</h4>
  <ul>
    <li><a href="https://www.linkedin.com/company/popnest/posts/?feedView=all">Popnest en LinkedIn</a></li>
    <li><a href="https://www.flexjobs.com/blog/post/hybrid-work-model-guide/">FlexJobs: Guía para el modelo híbrido</a></li>
    <li><a href="https://www.forbes.com/sites/forbeshumanresourcescouncil/2023/06/15/hybrid-workspaces-strategies/">Forbes: Estrategias para espacios híbridos</a></li>
  </ul>
      `,
    },
    {
      post_id: '3',
      post_keywords:
        'Espacio de trabajo, Popnest, Productividad, Energía colectiva, Trabajo colaborativo, Enfoque creativo, Motivación, Comunidad emprendedora, Networking, Desarrollo de proyectos.',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title:
        '¿Por qué elegir un espacio Popnest para iniciar y desarrollar un nuevo proyecto?',
      post_detail:
        'La energía colectiva impulsa la productividad y ayuda a mantener el enfoque. Ver a otros trabajar en sus proyectos crea un ambiente positivo que inspira a avanzar en el propio proceso creativo.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQFl2iVwj0GxZg/feedshare-shrink_1280/feedshare-shrink_1280/0/1731996079833?e=1746662400&v=beta&t=VPCehE-VEmTrshXeDYB_30q0Mu9bn5ABppyzStsWnpc',
      post_date: '03.12.24',
      longDescription: `
        <p>Iniciar y desarrollar un nuevo proyecto requiere un entorno adecuado que fomente la productividad, el enfoque y la creatividad. En Popnest, ofrecemos espacios diseñados específicamente para potenciar el rendimiento de emprendedores, freelancers y equipos de trabajo.</p>
        
        <p>Trabajar en un espacio compartido genera múltiples beneficios:</p>
        <ul>
          <li><strong>Energía Colectiva:</strong> Estar rodeado de personas motivadas impulsa la productividad y ayuda a mantener la concentración.</li>
          <li><strong>Inspiración y Enfoque:</strong> Ver a otros trabajar en sus proyectos crea un ambiente positivo que incentiva a avanzar en el propio proceso creativo.</li>
          <li><strong>Oportunidades de Networking:</strong> La interacción con otros profesionales abre puertas a colaboraciones, alianzas estratégicas y nuevas oportunidades de negocio.</li>
          <li><strong>Infraestructura Óptima:</strong> Nuestros espacios cuentan con internet de alta velocidad, salas de reuniones, áreas de descanso y un diseño pensado para maximizar la eficiencia laboral.</li>
          <li><strong>Flexibilidad y Comodidad:</strong> Ofrecemos opciones adaptadas a diferentes necesidades, desde escritorios individuales hasta oficinas privadas.</li>
        </ul>

        <p>Elegir un espacio Popnest no solo significa encontrar un lugar para trabajar, sino integrarse en una comunidad que impulsa el crecimiento profesional y el desarrollo de ideas innovadoras.</p>

        <h4>Referencias</h4>
        <ul>
          <li><a href="https://www.popnest.com">Popnest: Espacios diseñados para la productividad</a></li>
          <li><a href="https://www.coworkingresources.org">Coworking Resources: Ventajas de los espacios colaborativos</a></li>
          <li><a href="https://www.forbes.com">Forbes: Cómo los coworkings potencian la innovación</a></li>
        </ul>
      `,
    },
    {
      post_id: '4',
      post_keywords:
        'Resiliencia laboral, bienestar en el trabajo, productividad, espacios de trabajo flexibles, fuerza laboral resiliente, salud mental en la oficina, espacios inspiradores, cultura organizacional',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: '¿Cómo tener una fuerza de trabajo resiliente?',
      post_detail:
        'La resiliencia es clave para el éxito en el entorno laboral actual. En Popnest, ofrecemos espacios flexibles e inspiradores para fortalecer la productividad y el bienestar.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQGXxOWBEdKvxw/feedshare-shrink_1280/feedshare-shrink_1280/0/1729747407868?e=1746662400&v=beta&t=oC4IJCiJbZDrRVaiykCVy-YtHPm6-RjE5hoxNUqZ_2w',
      post_date: '03.11.24',
      longDescription: `
       <p>La resiliencia se ha convertido en un factor clave para el éxito y la productividad en el entorno laboral actual. A medida que las empresas enfrentan desafíos y cambios constantes, contar con una fuerza de trabajo resiliente permite adaptarse rápidamente a nuevas circunstancias y superar obstáculos de manera efectiva.</p>
  <p>En Popnest, entendemos la importancia de crear espacios de trabajo que fomenten esta resiliencia. Nuestros espacios flexibles e inspiradores no solo están diseñados para optimizar la productividad, sino también para promover el bienestar y la salud mental de los empleados. Al proporcionar entornos colaborativos y adaptables, las empresas pueden fortalecer la capacidad de sus equipos para afrontar retos y mantener un alto nivel de rendimiento.</p>
  <p>Algunas de las ventajas de un espacio de trabajo resiliente incluyen:</p>
  <ul>
    <li><strong>Adaptabilidad:</strong> Espacios que se ajustan a las necesidades cambiantes de los equipos.</li>
    <li><strong>Bienestar Integral:</strong> Áreas diseñadas para el equilibrio mental y físico de los trabajadores.</li>
    <li><strong>Colaboración y Comunidad:</strong> Fomentar una cultura organizacional de apoyo mutuo y trabajo en equipo.</li>
    <li><strong>Estímulo Creativo:</strong> Entornos que inspiran innovación y pensamiento creativo.</li>
  </ul>
  <p>En un mundo de constantes transformaciones, las empresas que promuevan la resiliencia dentro de sus equipos estarán mejor preparadas para enfrentar lo que venga.</p>
  <h4>Referencias</h4>
  <ul>
    <li><a href="https://www.popnest.com">Popnest: Espacios flexibles para equipos resilientes</a></li>
    <li><a href="https://www.forbes.com">Forbes: La importancia de la resiliencia en el trabajo</a></li>
  </ul>
      `,
    },
  ];

  const hostCatEntriesData = [
    {
      post_id: '5',
      post_keywords:
        'Inteligencia Artificial, Recursos Humanos, Gestión del Talento, Transformación Digital, AI en Empresas, Impacto de la IA, Tecnología en Recursos Humanos, Innovación en Recursos Humanos, Toma de decisiones, Factor Humano, IA en Selección de Personal, Futuro del Trabajo, Ética en la IA, Automatización en Recursos Humanos',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: 'La IA en Recursos Humanos: ¿Aliado o enemigo?',
      post_detail:
        'La inteligencia artificial ha llegado para transformar la gestión del talento, pero ¿su impacto es siempre positivo? ¿Hasta dónde puede llegar sin afectar el factor humano en la toma de decisiones?',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4D12AQFcnmPqogVluQ/article-cover_image-shrink_423_752/B4DZUBDYG_HYAc-/0/1739479419497?e=1749081600&v=beta&t=w2qJmOcC6_fhkVboHyqktdg-Z_FfD0smnEBNLMdevus',
      post_date: '13.02.25',
      longDescription: `
       <p>La inteligencia artificial ha emergido como una de las principales fuerzas transformadoras en los Recursos Humanos. Desde la automatización de tareas repetitivas hasta la mejora en los procesos de selección, la IA ofrece un sinfín de beneficios. Sin embargo, también plantea interrogantes sobre su impacto en la toma de decisiones y en la relación humana dentro del lugar de trabajo.</p>
  <p>En el contexto de la gestión del talento, la IA puede ser una aliada invaluable para mejorar la eficiencia y precisión en procesos como la selección de personal, la evaluación de desempeño y la capacitación. No obstante, también surgen preocupaciones sobre el reemplazo de empleos, la imparcialidad de los algoritmos y el riesgo de deshumanizar las decisiones que afectan la vida laboral de los empleados.</p>
  <p>Los principales beneficios de la IA en Recursos Humanos incluyen:</p>
  <ul>
    <li><strong>Automatización de tareas:</strong> La IA puede encargarse de tareas repetitivas, liberando a los profesionales de RR.HH. para que se enfoquen en actividades estratégicas y de mayor valor agregado.</li>
    <li><strong>Mejora en el reclutamiento:</strong> Los algoritmos de IA permiten realizar un análisis más exhaustivo de los candidatos, evaluando datos de manera más objetiva y eliminando sesgos humanos en el proceso.</li>
    <li><strong>Optimización de la capacitación:</strong> La IA puede personalizar los programas de formación de acuerdo con las necesidades y el rendimiento de cada empleado, lo que aumenta la efectividad de los mismos.</li>
  </ul>
  <p>Sin embargo, también es importante considerar los desafíos que la IA plantea, como el posible sesgo en los algoritmos, la falta de empatía en los procesos de toma de decisiones y la dependencia excesiva de la tecnología.</p>
  <p>El debate sobre si la IA es un aliado o enemigo en los Recursos Humanos sigue siendo relevante. Si bien es indudable que puede ofrecer numerosas ventajas, es fundamental que su implementación se haga de manera ética y responsable, asegurando que el factor humano siga siendo primordial en las decisiones clave dentro de la organización.</p>
  <h4>Referencias</h4>
  <ul>
    <li><a href="https://www.forbes.com/sites/forbeshumanresourcescouncil/2022/06/30/ai-in-human-resources-what-we-get-right-and-what-we-get-wrong/">Forbes: La IA en Recursos Humanos: Lo que hacemos bien y lo que no</a></li>
    <li><a href="https://www.shrm.org/resourcesandtools/hr-topics/technology/pages/ai-should-not-replace-hr-but-empower-it.aspx">SHRM: La IA no debe reemplazar a RR.HH., sino empoderarlo</a></li>
    <li><a href="https://hbr.org/2023/03/why-hr-needs-to-take-control-of-ai">Harvard Business Review: Por qué RR.HH. debe tomar control de la IA</a></li>
  </ul>
      `,
    },
    {
      post_id: '6',
      post_keywords: '1',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: '¿Qué te motiva a elegir trabajar desde casa o en un coworking?',
      post_detail:
        'Comodidad, flexibilidad, costos... ¿Sabías que hay una opción aún mejor y diferente? Descubre cómo Popnest revoluciona los espacios de trabajo.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQETStLNKGynxA/feedshare-shrink_800/feedshare-shrink_800/0/1716333802554?e=1746662400&v=beta&t=0gfd2jI2Lb2yBR5U50DyBKRJ6OrE35pttqUGhDaE5JA',
      post_date: '03.06.24',
      longDescription: `
       <p>En el mundo laboral actual, las opciones de espacio de trabajo se han diversificado, y ahora se nos presentan alternativas entre trabajar desde casa o en un coworking. Cada una tiene sus beneficios: la comodidad y flexibilidad del hogar, o la colaboración y dinámica de un espacio compartido. Sin embargo, ¿sabías que hay una opción aún más atractiva y diferente?</p>

<p>En Popnest, revolucionamos la forma de trabajar, ofreciendo un espacio único que combina lo mejor de ambos mundos: la comodidad de un entorno flexible con la interacción y creatividad de un coworking. Nuestros espacios están diseñados para brindarte todo lo que necesitas para maximizar tu productividad, mientras disfrutas de un ambiente inspirador y adaptable a tus necesidades.</p>

<p>Descubre cómo un espacio de trabajo como Popnest puede ofrecerte más que solo un lugar para trabajar, sino una comunidad que impulsa tu motivación y éxito. Ya sea que busques privacidad, flexibilidad o colaboración, Popnest tiene la solución ideal para ti.</p>

<h4>Beneficios de elegir Popnest:</h4>
<ul>
  <li><strong>Comodidad y Flexibilidad:</strong> Espacios diseñados para adaptarse a tu estilo de trabajo.</li>
  <li><strong>Ambiente Colaborativo:</strong> Rodeado de otros profesionales que pueden enriquecer tu experiencia.</li>
  <li><strong>Costos Accesibles:</strong> Beneficios de coworking sin los altos costos de oficinas tradicionales.</li>
  <li><strong>Inspiración y Productividad:</strong> Un lugar que te motiva a dar lo mejor de ti.</li>
</ul>

<p>Si aún te preguntas qué es lo que realmente te motiva, es momento de explorar cómo Popnest puede ser el espacio de trabajo que estabas buscando.</p>

      `,
    },
    {
      post_id: '7',
      post_keywords:
        'Espacio Popnest, Nuevo emprendimiento, Energía colectiva, Productividad, Enfoque, Trabajo en equipo, Ambiente positivo, Proceso creativo, Desarrollo de proyectos, Coworking, Emprendedores, Innovación, Inspiración, Colaboración.',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title:
        '¡¿Por qué ir a un espacio Popnest a empezar y desarrollar un nuevo emprendimiento?!',
      post_detail:
        'La energía colectiva impulsa la productividad y ayuda a mantener el enfoque. Ver a otros trabajar en sus proyectos crea un ambiente positivo que inspira a avanzar en el propio proceso creativo.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQHoQltBzt05Cw/feedshare-shrink_800/feedshare-shrink_800/0/1732689971171?e=1746662400&v=beta&t=iwwD2OahNDKhbrK6m5Liu-8mPZeJiNUMG-1mvlug1KY',
      post_date: '18.06.24',
      longDescription: `
        <p>En un <strong>espacio Popnest</strong>, la energía colectiva es el motor que impulsa la productividad y ayuda a mantener el enfoque. Ver a otros trabajar en sus proyectos crea un ambiente positivo que inspira a avanzar en el propio proceso creativo.</p>
<h5>Beneficios de un espacio Popnest:</h5>
<ul>
  <li><strong>Ambiente colaborativo:</strong> Rodearse de personas trabajando en sus propios proyectos fomenta la creatividad y el intercambio de ideas.</li>
  <li><strong>Flexibilidad:</strong> Acceso a espacios de trabajo adaptados a las necesidades del emprendedor, con opciones para distintos tipos de trabajo.</li>
  <li><strong>Recursos compartidos:</strong> Desde escritorios hasta salas de reuniones equipadas, todo lo necesario para el desarrollo de un nuevo emprendimiento.</li>
</ul>
<p>Este entorno no solo maximiza la productividad, sino que también permite crear un ecosistema de apoyo para emprendedores que están en las primeras etapas de su viaje. Si estás empezando o desarrollando tu proyecto, un espacio Popnest te proporciona todo lo que necesitas para avanzar en tus metas.</p>
<h4>Referencias</h4>
<ul>
  <li><a href="https://www.popnest.com">Popnest</a></li>
  <li><a href="https://www.coworkingresources.org">Coworking Resources</a></li>
  <li><a href="https://www.entrepreneur.com">Entrepreneur: Tips for new startups</a></li>
</ul>

      `,
    },
  ];

  const guestCatEntriesData = [
    {
      post_id: '7',
      post_keywords:
        'Prestaciones Flexibles, Trabajo Híbrido, Bienestar Laboral, Retención de Talento, Flexibilidad Laboral, Modelos Híbridos, Recursos Humanos, Employer Branding, Beneficios Laborales, Cultura Organizacional, Teletrabajo, Salud y Bienestar, Transformación Digital, Gestión del Talento',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: 'Las prestaciones flexibles son clave para retener talento en modelos híbridos.',
      post_detail:
        '¿Tu empresa ya ofrece este tipo de prestaciones? Descubre cómo el #TrabajoHíbrido y el #BienestarLaboral pueden mejorar la #RetenciónDeTalento en tu organización.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4D22AQFsxxtdk_fWTw/feedshare-shrink_2048_1536/B4DZPW9f3CHcAs-/0/1734478267139?e=1746662400&v=beta&t=1_m53QQFnFxvtf-eF40WGOwCTjrhr4wk8-tiZDgWkOw',
      post_date: '03.01.25',
      longDescription: `
        <p>En el debate entre <strong>trabajo remoto</strong> y <strong>espacios de coworking</strong>, cada opción tiene ventajas y desventajas.</p>
        <h5>Trabajo Remoto</h5>
        <p>Trabajar desde casa es cómodo y económico, pero puede generar <em>aislamiento</em> y menor productividad debido a las distracciones del hogar.</p>
        <h5>Espacios de Coworking</h5>
        <p>Los coworkings ofrecen:</p>
        <ul>
          <li>Un <strong>ambiente profesional</strong> que mejora el enfoque.</li>
          <li>Posibilidades de <strong>networking</strong> con otros profesionales.</li>
          <li>Instalaciones como internet de alta velocidad y salas de reuniones.</li>
        </ul>
        <p>La mejor opción dependerá de tus necesidades y estilo de trabajo. Si buscas productividad y colaboración, un coworking es ideal.</p>
        <h4>Referencias</h4>
        <ul>
          <li><a href="https://www.cnbc.com">CNBC: Coworking frente al teletrabajo</a></li>
          <li><a href="https://www.bbc.com">BBC: ¿Espacios de coworking o casa?</a></li>
          <li><a href="https://www.fastcompany.com">FastCompany: Eficiencia en coworking</a></li>
        </ul>
      `,
    },
    {
      post_id: '8',
      post_keywords:
        'Querétaro, trabajo, espacio profesional, reserva on demand, reuniones, trabajo remoto, comodidad, privacidad, ambiente inspirador, espacio de trabajo, oficina profesional.',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title: '¿Viajas a Querétaro por trabajo? Reserva este lugar On Demand',
      post_detail:
        'Entra a la web y agenda en minutos. Si necesitas un espacio profesional para trabajar o realizar una reunión en Querétaro, descubre este lugar, un espacio diseñado para ofrecer comodidad, privacidad y un ambiente inspirador.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQEqjKWop63dAQ/feedshare-shrink_1280/feedshare-shrink_1280/0/1732755674508?e=1746662400&v=beta&t=b0z8Rul3bgvaFh_2ADUA9-MytDBVwuE7qPCusXDbZ0s',
      post_date: '03.12.24',
      longDescription: `
      <p>Si viajas a <strong>Querétaro</strong> por trabajo y necesitas un espacio profesional para trabajar o realizar una reunión, Popnest te ofrece la opción ideal.</p>
<h5>Beneficios del espacio Popnest:</h5>
<ul>
  <li><strong>Comodidad:</strong> Un entorno diseñado para maximizar la productividad y el confort.</li>
  <li><strong>Privacidad:</strong> Espacios que garantizan confidencialidad durante tus reuniones o trabajo personal.</li>
  <li><strong>Ambiente inspirador:</strong> Rodeado de profesionales que comparten el mismo enfoque y energía positiva.</li>
</ul>
<p>Entra a la web y agenda en minutos. Si buscas un espacio flexible y funcional, Popnest es la opción perfecta para optimizar tu tiempo de trabajo en Querétaro.</p>
<h4>Reservar espacio</h4>
<ul>
  <li><a href="https://www.popnest.com">Popnest - Reserva tu espacio</a></li>
</ul>

      `,
    },
    {
      post_id: '9',
      post_keywords:
        'Aplicaciones de productividad, Herramientas de productividad, Toma de notas, Tableros Kanban, Colaboración en equipo, Automatización de tareas, Integración con Google Drive, Integración con Slack, Aplicaciones móviles, Plantillas prediseñadas, Gestión de bases de datos, Soporte al cliente, Aplicaciones para productividad personal.',
      author_id: '1',
      type_id: '1',
      state_id: '1',
      post_title:
        'Recomendaciones de aplicaciones de productividad y sus principales características',
      post_detail:
        'Descubre las mejores aplicaciones de productividad, con características como toma de notas, tableros Kanban, colaboración en equipo, automatizaciones, integraciones con Google Drive y Slack, aplicaciones móviles, plantillas prediseñadas, uso intuitivo, gestión de bases de datos y soporte al cliente.',
      entryImage:
        'https://media.licdn.com/dms/image/v2/D4E22AQESQwGxdUON7w/feedshare-shrink_800/feedshare-shrink_800/0/1732599696034?e=1746662400&v=beta&t=ZOR0yGTlyPG4JZe2ImnVU_BDduNw4err6UNM8Wqq_EU',
      post_date: '22.06.24',
      longDescription: `
       <p>Las aplicaciones de productividad se han convertido en herramientas esenciales para mejorar la eficiencia y la organización tanto en el trabajo como en la vida personal. Existen múltiples opciones que ofrecen funcionalidades como la toma de notas, la creación de tableros Kanban, y la colaboración en equipo. Estas aplicaciones permiten automatizar tareas, integrar servicios como Google Drive y Slack, y contar con aplicaciones móviles que facilitan el acceso a la información desde cualquier lugar.</p> <p>Además, muchas de estas herramientas incluyen plantillas prediseñadas que simplifican el proceso de organización, así como opciones de gestión de bases de datos para estructurar y analizar información. Con un uso intuitivo y soporte al cliente de calidad, estas aplicaciones de productividad se adaptan a las necesidades de usuarios individuales y equipos de trabajo, optimizando los flujos de trabajo y mejorando la colaboración.</p> <h4>Referencias:</h4> <ul> <li><a href="https://www.todoist.com">Todoist: Herramienta de productividad para gestión de tareas</a></li> <li><a href="https://www.trello.com">Trello: Tableros Kanban y gestión de proyectos</a></li> <li><a href="https://www.notion.so">Notion: Aplicación todo-en-uno para productividad</a></li> <li><a href="https://www.slack.com">Slack: Comunicación y colaboración de equipo</a></li> </ul>
      `,
    },
  ];

  return (
    <FlexContainer className={'flex-column width100 blogView'}>
      <HelmetComponent
        title={lenguageData === 'EN' ? 'Blog - Popnest' : 'Blog - Popnest'}
        description={lenguageData === 'EN' ? enDescription : esDescription}
        graphTitle={lenguageData === 'EN' ? 'Blog - Popnest' : 'Blog - Popnest'}
        graphDescription={lenguageData === 'EN' ? enDescription : esDescription}
      />
      <FlexContainer className={'flex-column banner width100 items-align-left'}>
        {!isShowDetail && (
          <>
            <FlexContainer className={'info-box flex-column align-items-center'}>
              <Label className="text-40 m-text-32 bold padlr100 m-padlr20">
                <strong>Blog de Popnest</strong>
              </Label>
            </FlexContainer>
            <img
              src="spaces/spaceslider.png"
              alt="Foto 1"
              style={{ width: '100%', height: '500px' }}
              className={''}
            />
          </>
        )}
        {isShowDetail && (
          <>
            <FlexContainer className={'info-box flex-column align-items-center'}>
              <Label className="text-40 m-text-28 bold padlr100 m-padlr20">
                <strong>{detailData?.post_title}</strong>
              </Label>
            </FlexContainer>
            <img
              src={detailData?.entryImage}
              alt="Detalle de foto de entrada"
              style={{ width: '100%', height: '500px' }}
              className={''}
            />
          </>
        )}
      </FlexContainer>
      {!isShowDetail && (
        <FlexContainer className={'flex-column margt40 padlr80 m-padlr10'}>
          <EntriesRow
            category={'Espacios'}
            entriesData={spacesCatEntriesData}
            setDetailEntryData={setDetailEntryData}
          />
          <EntriesRow
            category={'Anfitriones'}
            entriesData={hostCatEntriesData}
            setDetailEntryData={setDetailEntryData}
          />
          <EntriesRow
            category={'Invitados'}
            entriesData={guestCatEntriesData}
            setDetailEntryData={setDetailEntryData}
          />
        </FlexContainer>
      )}
      {isShowDetail && (
        <FlexContainer className={'margt40 padlr100 m-padlr10'}>
          <FlexContainer className={'flex-column format40 align-items-end'}>
            <Label className="text-22 m-text-18 margt10 marglr10 bold">
              {detailData?.post_date} -
            </Label>
            <button
              type="button"
              className={
                'bgGray050 border-rad4px borderGray050 fontGray500 text-16 margtb40 margr30'
              }
              onClick={() => closeDetailEntryData()}
            >
              <span className={'padlr10'} style={{ display: 'inline-flex', gap: '6px' }}>
                <i className={'fa fa-arrow-left margr6'} aria-hidden="true" />{' '}
                {lenguageData === 'EN' ? 'Back' : 'Atrás'}
              </span>
            </button>
          </FlexContainer>
          <FlexContainer className={'flex-column format100'}>
            <Label className="text-26 m-text-18 margb40 margt10 bold">
              <strong>{detailData?.post_title}</strong>
            </Label>
            <Label className="text-18 m-text-14 margb10 bold">{detailData?.post_detail}</Label>
            <Label
              className="text-20 m-text-16 margb60"
              dangerouslySetInnerHTML={{ __html: detailData?.longDescription }}
            />
            <Label className="text-20 m-text-16 margb60">
              <YouTubeEmbed />
            </Label>
          </FlexContainer>
        </FlexContainer>
      )}
    </FlexContainer>
  );
};

export default Blog;
